import React from 'react'
import classnames from 'classnames'
import './Thumbnail.scss'
import { useCurrencies } from '@/hooks' 
import CurrencyIcon from '@/components/currencyIcon'

const Thumbnail = ({
  image,
  currencyId,
  variant = 'circle',
  className,
  eager = false,
  alt = 'thumbnail',
}) => {
  const currencies = useCurrencies().currencies
  const icon = currencyId && currencies[currencyId] && <CurrencyIcon currency={currencies[currencyId]} width="24px" />

  const classList = classnames('thumbnail', className, {
    'thumbnail--circle': variant === 'circle',
    'thumbnail--rect': variant === 'rect',
  })

  if (typeof image === 'string') {
    return (
      <i className={classList}>
        <img
          className="thumbnail__img"
          src={image}
          alt={alt}
          title={alt}
          loading={eager ? 'eager' : 'lazy'}
          decoding={eager ? 'sync' : 'async'}
          fetchPriority={eager ? 'high' : 'auto'}
        />
        {icon}
      </i>
    )
  }

  return (
    <i className={classList}>
      {image}
      {icon}
    </i>
  )
}

export default Thumbnail
